import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { AD_UNIT_UPDATE_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const UPDATE_AD_UNIT: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${AD_UNIT_UPDATE_FRAGMENT}
  ${ERROR_FRAGMENT}

  mutation updateAdUnit($input: UpdateAdUnitInput!) {
    updateAdUnit(input: $input) {
      adUnit {
        ...AdUnitUpdateFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
